import { atlasKey, type Manifest } from '../assets';
import { chooseDirection } from './direction';

export interface AtlasClip { key: string; flipX: boolean; scale: number; }
export interface AtlasQuery { sprite: string; anim: string; facingX: number; facingY: number; }

// Clip atlas pour (sprite, anim, facing) : clip demandé, sinon même animation dans une autre direction, sinon static.
// `ready(key)` : texture chargée et animation enregistrée ; sans cela le clip est écarté (jamais de texture manquante à l'écran).
export function resolveAtlasClip(m: Manifest, e: AtlasQuery, ready: (key: string) => boolean): AtlasClip | null {
  const a = m.atlases?.[e.sprite];
  if (!a) return null;
  const animation = a.animMap[e.anim] ?? 'static';
  const { dir, flipX } = chooseDirection(e.facingX, e.facingY, a.directions);
  const candidates = [`${animation}${dir}`, ...a.directions.map((d) => `${animation}${d}`), ...a.directions.map((d) => `static${d}`)];
  const clip = candidates.find((c) => a.clips[c] && ready(atlasKey(e.sprite, c)));
  return clip ? { key: atlasKey(e.sprite, clip), flipX, scale: a.displayScale } : null;
}

